import { IEmployeeFormState } from '@/store/employee-form';
import { IEmployeeFormGetters } from './getters.types';
import {
  IEmployeeFormSubmission,
  EmployeeFormSubmission,
  IEmployeeFormSubmissionChecklist,
  EmployeeFormSubmissionChecklist,
  IDepartment,
  Department,
  IEmployeeFormSubmissionComment,
  EmployeeFormSubmissionComment,
  IUser,
  User,
  IDepartmentData
} from '@/models';
import { ITransition, Transition } from '@/models/transition';

export const getters: IEmployeeFormGetters = {
  getEmployeeFormSubmissionCount(state: IEmployeeFormState): number {
    return state.count;
  },

  //submissions
  getEmployeeFormSubmissions(
    state: IEmployeeFormState
  ): IEmployeeFormSubmission[] {
    return state.employeeFormSubmissions.map(
      data => new EmployeeFormSubmission(data)
    );
  },

  getEmployeeFormSubmissionById: (state: IEmployeeFormState) => (
    id: number
  ): IEmployeeFormSubmission | undefined => {
    const data = (state.employeeFormSubmissions as IEmployeeFormSubmission[]).find(
      form => form.id === id
    );
    if (!data) {
      return undefined;
    }

    return new EmployeeFormSubmission(data as IEmployeeFormSubmission);
  },

  // activities
  getEmployeeFormSubmissionActivities: (
    state: IEmployeeFormState
  ): ITransition[] => {
    return state.activities.map(activity => new Transition(activity));
  },

  getEmployeeFormSubmissionChecklists(
    state: IEmployeeFormState
  ): IEmployeeFormSubmissionChecklist[] {
    return state.employeeFormChecklists.map(
      data => new EmployeeFormSubmissionChecklist(data)
    );
  },

  getChecklistAssigneeOptions(state: IEmployeeFormState): IUser[] {
    return state.checklistAssigneeOptions.map(data => new User(data));
  },

  getEmployeeFormSubmissionChecklistsByDepartment: (
    state: IEmployeeFormState
  ) => (id: number): IEmployeeFormSubmissionChecklist[] => {
    const checklists = state.employeeFormChecklists.filter(
      checklist =>
        (checklist.todo_template.todo_department as IDepartmentData).id === id
    );

    return checklists.map(data => new EmployeeFormSubmissionChecklist(data));
  },

  getEmployeeFormSubmissionChecklistById: (state: IEmployeeFormState) => (
    id: number
  ): IEmployeeFormSubmissionChecklist | undefined => {
    const data = state.employeeFormChecklists.find(
      template => template.id === id
    );
    if (!data) {
      return undefined;
    }

    return new EmployeeFormSubmissionChecklist(data);
  },

  getEmployeeFormSubmissionDepartments(
    state: IEmployeeFormState
  ): IDepartment[] {
    return state.employeeFormDepartments.map(data => new Department(data));
  },

  getEmployeeFormSubmissionComments: (
    state: IEmployeeFormState
  ): IEmployeeFormSubmissionComment[] => {
    return state.comments.map(data => new EmployeeFormSubmissionComment(data));
  },

  getEmployeeFormSubmissionCommentById: (state: IEmployeeFormState) => (
    id: number
  ): IEmployeeFormSubmissionComment | undefined => {
    const data = state.comments.find(
      paymentrequisition => paymentrequisition.id === id
    );
    if (!data) {
      return undefined;
    }

    return new EmployeeFormSubmissionComment(data);
  },

  getLastCreatedCommentId(state: IEmployeeFormState): number | null {
    return state.lastCreatedCommentId;
  },

  getEmployeeFormSubmissionMentionableUsers(
    state: IEmployeeFormState
  ): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
